export const fieldTypes = {
    TEXT: 'text',
    SELECT: 'select',
    MULTY_SELECT: 'multySelect',
    PHONE: 'phone',
    EMAIL: 'email',
    DATE: 'date',
}

export const consentFieldType = 'consent'

export const fieldOptions = [
    {label: 'Telefono', value: fieldTypes.PHONE},
    {label: 'Email', value: fieldTypes.EMAIL},
    {label: 'Testo semplice', value: fieldTypes.TEXT},
    {label: 'Lista a scelta singola', value: fieldTypes.SELECT},
    {label: 'Lista a scelta multipla', value: fieldTypes.MULTY_SELECT},
    {label: 'Data', value: fieldTypes.DATE},
]


export const consentTypes = {
    LINK: 'link',
    UPLOADED: 'uploaded',
    TEXT: 'text'
}

export const skipTypes = {
    NO_SKIP: '',
    SKIP_ICON: 'icon',
    SKIP_BUTTON: 'button'
}
export const skipOptions = [
    {label: 'Icona "X" in alto', input: skipTypes.SKIP_ICON},
    {label: 'Pulsante "No grazie"', input: skipTypes.SKIP_BUTTON},
    {label: 'Il form è obbligatorio', input: skipTypes.NO_SKIP},
]

export const elementRadiusOptions = [
    {iconName: 'cipRound0', value: 0},
    {iconName: 'cipRound1', value: 12},
    {iconName: 'cipRound2', value: 24},
]

export const fieldSizes = {
    FULL: 'full',
    HALF: 'half',
    THIRD: 'third'
}

export const fieldSizeOptions = [
    {label: 'Larghezza piena (su desktop: 1 campo per riga, su mobile: sempre 1 per riga)', value: fieldSizes.FULL},
    {label: 'Mezza larghezza (su desktop/tablet: 2 campi per riga, su mobile: 1 per riga)', value: fieldSizes.HALF},
    {label: 'Un terzo larghezza (su desktop: 3 campi per riga, su tablet/mobile: 1 per riga)', value: fieldSizes.THIRD},
]

export const defaultFieldSize = fieldSizes.FULL

export function generateKey(text) {
    if (text instanceof Object) text = text = text['it']
    if (!text || text.length < 1) return ''
    return text.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, "").replace(/ /g, '_')
}

export const defaultFields = [
    {
        order: 1,
        id: 1,
        type: fieldTypes.EMAIL,
        name: {it: 'Email', en: 'Email'},
        key: 'email',
        editable: false,
        size: defaultFieldSize
    },
    {
        order: 2,
        id: 2,
        type: fieldTypes.TEXT,
        name: {it: 'Nome', en: 'First Name'},
        key: 'first_name',
        editable: true,
        size: fieldSizes.HALF
    },
    {
        order: 3,
        id: 3,
        type: fieldTypes.TEXT,
        name: {it: 'Cognome', en: 'Last Name'},
        key: 'last_name',
        editable: true,
        size: fieldSizes.HALF
    },
    {
        order: 4,
        id: 4,
        type: fieldTypes.PHONE,
        name: {it: 'Telefono', en: 'Phone'},
        key: 'phone',
        editable: true,
        size: defaultFieldSize
    },
    {
        order: 5,
        id: 5,
        type: fieldTypes.TEXT,
        name: {it: 'Comune di residenza', en: 'City'},
        key: 'city',
        editable: true,
        size: defaultFieldSize
    },
]

export const defaultConsents = []

export const generateRandomId = () => {
    return Math.random().toString(36).substring(7)
}